import { useEffect } from 'react'

import { SET_ACTIVE_STATE } from 'app-redux/active/actions/types'
import { generateIsLarge, generateIsMidsized, generateIsMobile } from 'app-redux/active/initialState'
import { store } from 'app-redux/store'

import ToastContainer from 'components/toasts/ToastContainer'

import GlobalToolbar from 'components/misc/GlobalToolbar'
import Headers from 'components/misc/Headers'
import Image from 'components/elements/Image'
import NavigationDrawer, { useNavdrawerSwipe } from '../GlobalToolbar/NavigrationDrawer'
import InhouseFixedAd from 'components/advertisments/InhouseFixedAd'
import VideoAd from 'components/advertisments/InhouseVideoAd'

import styles from './simplePageWrapper.module.scss'

type Props = {
  children: React.ReactNode
  title?: string
  robots?: string
  description?: string
  className?: string
  containerClassName?: string
  noLinks?: boolean
  noAccount?: boolean
  loginRedirectOverride?: string
  noAds?: boolean
}

const SimplePageWrapper = ({
  children,
  title,
  robots,
  description,
  className,
  containerClassName,
  noLinks,
  noAccount,
  loginRedirectOverride,
  noAds = false,
}: Props) => {
  // const swipeRef = useNavdrawerSwipe()

  const updateDimensions = () => {
    const isMobile = generateIsMobile()
    const isMidsize = generateIsMidsized()
    const isLarge = generateIsLarge()

    store.dispatch({ type: SET_ACTIVE_STATE, payload: { isMobile, isMidsize, isLarge } })
  }

  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)

    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  return (
    <>
      <div className={`${styles.container} ${containerClassName || ''}`}>
        <GlobalToolbar noSearch noLinks={noLinks} noAccount={noAccount} loginRedirectOverride={loginRedirectOverride} />

        <Image className={styles.sketch} alt="sketch1" src="/images/sketch1.svg" style={{ top: '-20%', left: '-5%' }} />
        <Image className={styles.sketch} alt="sketch6" src="/images/sketch3.svg" style={{ top: '60%', left: '70%' }} />
        <Image className={styles.sketch} alt="sketch7" src="/images/sketch4.svg" style={{ top: '3%', left: '65%' }} />
        <Image className={styles.sketch} alt="sketch8" src="/images/sketch6.svg" style={{ top: '60%', left: '-10%' }} />

        <div className={styles.topGradientMask} />
        <div className={styles.bottomGradientMask} />

        <div className={`${styles.content} ${className || ''}`}>{children}</div>

        <Headers description={description} title={title} robots={robots} />
      </div>

      {!noAds && (
        <>
          <InhouseFixedAd />
          <VideoAd />
        </>
      )}

      {!noLinks && !noAccount && <NavigationDrawer />}
      <ToastContainer />
    </>
  )
}

export default SimplePageWrapper
